import { Route } from 'react-router';
import { Layout } from './components/layout/Layout';
import { Home } from './components/Home/Home';
import { Olc } from './components/Home/Olc';
import { Donate } from './components/Donate/Donate';
import { HMAs } from './components/HMAs/HMAs';
import { PaymentCallback } from './components/Donate/PaymentCallback';
import './custom.css'
import { useAuth } from './services';
import { Faq } from './components/faq/Faq';
import './components/layout/Uswds.css';

export function App() {
  useAuth();

  return (
    <Layout >
      <Route path='/HMAs' component={HMAs} />
      <Route path='/Donate' component={Donate} />
      <Route exact path='/' component={Home} />
      <Route path='/olc' component={Olc} />
      <Route path='/PaymentCallback' component={PaymentCallback} />
      <Route path='/Faq' component={Faq} />
    </Layout>
  );
}
